export default {
  messages: {
    REQUEST_APP_CONTROL: 'REQUEST_APP_CONTROL',
    REQUEST_APP_CONTROL_RESPONSE: 'REQUEST_APP_CONTROL_RESPONSE',
    APP_INSTANCE_LOADED: 'APP_INSTANCE_LOADED',
    APP_INSTANCE_LOADED_RESPONSE: 'APP_INSTANCE_LOADED_RESPONSE',
  },
  events: {
    REQUEST_APP_CONTROL_RESPONSE: 'REQUEST_APP_CONTROL_RESPONSE',
    APP_INSTANCE_LOADED_RESPONSE: 'APP_INSTANCE_LOADED_RESPONSE',
  },
  statuses: {
    REQUEST_CONTROL_READY: 'REQUEST_CONTROL_READY',
    REQUEST_CONTROL_PENDING: 'REQUEST_CONTROL_PENDING',
    REQUEST_CONTROL_FAILED: 'REQUEST_CONTROL_FAILED',
  },
  REQUEST_CONTROL_RESPONSE_TIMEOUT: 10000,
  RESPONSE_TIMEOUT: 200,
  READONLY_SYMBOL: Symbol('readonly'),
};
